import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { fetchBlog, resolveMediaUrl } from "@/lib/api";
import { BLOG } from "@/constants/testIds";
import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  useEffect(() => { fetchBlog().then(setArticles).catch(() => {}); }, []);

  return (
    <div className="pb-24">
      <SEO
        title="Blog Dermo Facial Asirox · Aparatología Estética Profesional"
        description="Blog SEO con análisis técnico para profesionales: protocolos dermo faciales, comparativas hidradermoabrasión vs RF vs ultrasonidos, rentabilidad de equipos dermo faciales, tendencias 2026 y guía de compra para clínicas estéticas."
        keywords="blog dermo facial, aparatología estética blog, comparativa equipos dermo faciales, protocolos faciales profesionales, rentabilidad clínica estética, tendencias dermo facial 2026, hidradermoabrasión vs radiofrecuencia, guía compra equipo facial"
      />
      <PageHero
        overline="Blog SEO · Asirox Insights"
        title="Análisis técnico"
        highlight="para profesionales del dermo facial estético."
        subtitle="Artículos creados por nuestro equipo de ingeniería especialmente para usted: protocolos clínicos, rentabilidad, tecnología dermo facial y tendencias del sector aparatológico estético."
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/blog-dermo-facial/${a.slug}`}
              data-testid={BLOG.card(a.slug)}
              className="group block border border-black/15 bg-[#f7ebd9] card-tilt overflow-hidden"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-black">
                <img src={resolveMediaUrl(a.hero_image)} alt={a.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-90"/>
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/60"/>
                <p className="absolute top-4 left-4 overline overline-on-dark">{a.category}</p>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-black/60 font-mono">
                  <Clock size={12} strokeWidth={1.6}/> <span>{a.read_time}</span>
                </div>
                <h3 className="font-heading text-xl font-bold mt-3 leading-snug ink-heading group-hover:text-black transition">{a.title}</h3>
                <p className="text-black/80 text-sm mt-3 leading-relaxed line-clamp-3">{a.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-[#3D1F0A] text-sm font-semibold">
                  Leer artículo
                  <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"/>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
